import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { RetailerNetworkLocationFilter } from '@occc/graphql';

import { RetailerNetworkUserDetailsLocationsTable } from './retailer-network-user-details-locations-table.component';

import { useGetRetailerNetworkLocations } from '../../../../data-access/queries';
import { routeCreator } from '../../../retailer-connect.utils';

type RetailerNetworkUserDetailsLocationsTableContainerProps = {
  filter: RetailerNetworkLocationFilter;
  retailerNetworkUuid: string;
  handleRemoveUserFromLocation: (locationUuid: string) => void;
  isCurrentUserPermittedToDisassociate: boolean;
};

const RetailerNetworkUserDetailsLocationsTableContainer = ({
  filter,
  retailerNetworkUuid,
  handleRemoveUserFromLocation,
  isCurrentUserPermittedToDisassociate,
}: RetailerNetworkUserDetailsLocationsTableContainerProps) => {
  const navigate = useNavigate();

  const locationsData = useGetRetailerNetworkLocations({ filter });

  const handleOpenLocationDetailsPage = useCallback(
    (locationUuid: string) => {
      navigate(routeCreator.locationDetails(retailerNetworkUuid, locationUuid));
    },
    [navigate, retailerNetworkUuid],
  );

  return (
    <RetailerNetworkUserDetailsLocationsTable
      locationsData={locationsData}
      handleOpenLocationDetailsPage={handleOpenLocationDetailsPage}
      handleRemoveUserFromLocation={handleRemoveUserFromLocation}
      isCurrentUserPermittedToDisassociate={isCurrentUserPermittedToDisassociate}
    />
  );
};

export default RetailerNetworkUserDetailsLocationsTableContainer;
